import styled from "styled-components";
import BsModal from "react-bootstrap/Modal";

export const Modal = styled(BsModal)`
  .modal-content {
    padding: 0 15px;
  }
`;
